import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

export class FeatureController
{
    // see "MAM-2155 - Update prod with access control"
    public areCloudFunctionsEnabled():boolean
    {
        return this._getCurrentOrgFeature('areCloudFunctionsEnabled', true);
    }

    // see "MAM-2155 - Update prod with access control"
    public isExcelImportEnabled():boolean
    {
        return this._getCurrentOrgFeature('isExcelImportEnabled', true);
    }

    // see "MAM-2155 - Update prod with access control"
    public canCreateNewOrganization():boolean
    {
        return this._getCurrentOrgFeature('canCreateNewOrganization', true);
    }

    public canDeleteVersionSnapshots():boolean
    {
        return this._getCurrentOrgFeature('canDeleteVersionSnapshots', false);
    }

    private _getCurrentOrgFeature<T>(featureName:string, defaultValue:T):T
    {
        const {context} = controllers;

        const featuresConfig = ConfigUtil.featuresRegistry();
        const features = featuresConfig.perOrg
            ? featuresConfig.perOrg[context.currentOrganizationSid()] || {}
            : {};

        const value = features[featureName];
        return value != null ? value as T : defaultValue;
    }
}
